import { ClientItemId } from 'owa-client-ids';
import { action } from 'satcheljs';

export const clickCalendarEvent = action('clickCalendarEvent', (id: ClientItemId) => ({
    id,
}));

export const doubleClickCalendarEvent = action('doubleClickCalendarEvent', (id: ClientItemId) => ({
    id,
}));

export const resetCalendarView = action('resetCalendarView');
